/* Bookshelf Treasures — AJAX cart drawer */
(function () {
  const drawer = document.querySelector('[data-bt-cart]');
  if (!drawer) return;
  const body = drawer.querySelector('[data-bt-cart-body]');
  const foot = drawer.querySelector('[data-bt-cart-foot]');
  const subtotalEl = drawer.querySelector('[data-bt-cart-subtotal]');
  const countEls = document.querySelectorAll('[data-bt-cart-count]');
  /* /cart.js returns cents (unlike suggest.json). Tag with data-bt-money so the
     currency converter can re-render these dynamically-built prices. */
  const money = (c) => '$' + (c / 100).toFixed(2);
  const usd = (c) => (c / 100).toFixed(2);

  const open = () => { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; };
  const close = () => { drawer.hidden = true; document.documentElement.style.overflow = ''; };

  function renderItems(cart) {
    if (!cart.item_count) {
      body.innerHTML = '<div class="bt-drawer__empty"><h3>Your cart is empty</h3><p>Add a few brand-new books to get started.</p><a href="/collections/all" class="bt-btn bt-btn--secondary" style="margin-top:14px;">Continue shopping</a></div>';
      if (foot) foot.hidden = true;
    } else {
      body.innerHTML = '<div class="bt-li-list">' + cart.items.map(function (it) {
        const img = it.image ? '<img class="bt-li__img" src="' + it.image + '" alt="" width="56" height="78">' : '<span class="bt-li__img"></span>';
        const author = '';
        return '<div class="bt-li" data-bt-li data-key="' + it.key + '">' + img +
          '<div class="bt-li__mid"><p class="bt-li__t"><a href="' + it.url + '">' + it.product_title + '</a></p>' + author +
          '<div class="bt-li__row"><div class="bt-qty" data-bt-qty><button type="button" data-bt-minus aria-label="Decrease">−</button><span data-bt-q>' + it.quantity + '</span><button type="button" data-bt-plus aria-label="Increase">+</button></div>' +
          '<span class="bt-li__price" data-bt-money="' + usd(it.final_line_price) + '">' + money(it.final_line_price) + '</span></div>' +
          '<button type="button" class="bt-li__rm" data-bt-remove>Remove</button></div></div>';
      }).join('') + '</div>';
      if (foot) foot.hidden = false;
    }
    if (subtotalEl) {
      subtotalEl.setAttribute('data-bt-money', usd(cart.total_price));
      subtotalEl.textContent = money(cart.total_price);
    }
    countEls.forEach((e) => { e.textContent = cart.item_count; });
    renderLadder(cart);
    if (window.btCurrency && window.btCurrency.refresh) window.btCurrency.refresh();
  }

  /* Volume nudge in the drawer. Driven by the live cart, never by a cached count,
     so it cannot promise a tier the cart will not actually give. */
  const ladderEl = drawer.querySelector('[data-bt-cart-ladder]');
  const savedEl = drawer.querySelector('[data-bt-cart-saved]');
  const savedAmt = drawer.querySelector('[data-bt-cart-saved-amt]');
  let TIERS = [];
  try { TIERS = JSON.parse(ladderEl && ladderEl.getAttribute('data-tiers') || '[]'); } catch (e) { TIERS = []; }
  TIERS.sort((a, b) => a.qty - b.qty);

  function renderLadder(cart) {
    if (savedEl) {
      const d = cart.total_discount || 0;
      savedEl.hidden = d <= 0;
      if (savedAmt && d > 0) {
        // No "−" prefix: the currency converter rewrites textContent on any
        // [data-bt-money] node and would strip it anyway. "You save $2.99" reads fine.
        savedAmt.setAttribute('data-bt-money', usd(d));
        savedAmt.textContent = money(d);
      }
    }
    if (!ladderEl || !TIERS.length) return;
    const n = cart.item_count;
    if (!n) { ladderEl.hidden = true; return; }
    const next = TIERS.find((t) => n < t.qty);
    const earned = [...TIERS].reverse().find((t) => n >= t.qty);
    const b = (v) => '<b>' + v + '</b>';
    if (!next) ladderEl.innerHTML = 'Best price unlocked — ' + b(earned.pct + '% off') + ' this order';
    else if (!earned) ladderEl.innerHTML = 'Add ' + b(next.qty - n) + (next.qty - n === 1 ? ' more book' : ' more books') + ' to save ' + b(next.pct + '%');
    else ladderEl.innerHTML = 'Saving ' + b(earned.pct + '%') + ' — add ' + b(next.qty - n) + (next.qty - n === 1 ? ' more' : ' more') + ' for ' + b(next.pct + '%');
    ladderEl.hidden = false;
  }

  function refresh(openIt) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => { renderItems(c); if (openIt) open(); });
  }

  document.querySelectorAll('[data-bt-cart-open]').forEach((b) =>
    b.addEventListener('click', (e) => { e.preventDefault(); refresh(true); }));
  drawer.querySelectorAll('[data-bt-cart-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });

  // Intercept any add-to-cart form
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form.matches && form.matches('form[action*="/cart/add"]'))) return;
    e.preventDefault();
    const btn = form.querySelector('[name="add"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(() => refresh(true))
      .catch(() => form.submit())
      .finally(() => { if (btn) btn.removeAttribute('aria-busy'); });
  });

  // Qty +/- and remove (delegated)
  body.addEventListener('click', function (e) {
    const li = e.target.closest('[data-bt-li]');
    if (!li) return;
    const key = li.getAttribute('data-key');
    const q = parseInt(li.querySelector('[data-bt-q]').textContent, 10) || 0;
    let nq = null;
    if (e.target.closest('[data-bt-plus]')) nq = q + 1;
    else if (e.target.closest('[data-bt-minus]')) nq = q - 1;
    else if (e.target.closest('[data-bt-remove]')) nq = 0;
    if (nq === null) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: nq }),
    }).then((r) => r.json()).then(renderItems);
  });
})();
